import { Button } from '@mui/material';
import { SxProps } from '@mui/material/styles';
import { Link } from 'components/common/Link';
import { useServerTranslation } from 'hooks/useServerTranslation';

import { useNavigation } from 'hooks/useNavigation';

type CheckoutButtonProps = {
    label?: string;
    sx?: SxProps;
};

export default function CheckoutButton(props: CheckoutButtonProps) {
    const { label, sx } = props;

    const { t } = useServerTranslation();

    const { shop } = useNavigation();

    return (
        <Button
            href={shop.checkout}
            LinkComponent={Link}
            fullWidth
            variant="contained"
            sx={{
                height: 50,
                fontSize: 18,
                textTransform: 'uppercase',
                marginBottom: 2,
                ...sx,
            }}
        >
            {label ?? t('common.button.go-to-checkout')}
        </Button>
    );
}
